const devConfig = [
  {
    BRAND_CODE: '',
    VUE_APP_API_HOST: 'https://api-dev.clp.kr/anchor/',
    VUE_APP_API_HOST_ENTERPRISE: 'https://api-dev.clp.kr/anchor/',
    VUE_APP_API_HOST_STANDARD: 'https://api-dev.clp.kr/anchor/',
    VUE_APP_PAYMENT_HOST: 'http://localhost:8080',
    VUE_FIREBASE_INIT: {
      apiKey: 'AIzaSyA5nVm2-jac04okMOD4_qotVz3YSddVAlc',
      authDomain: 'anchor-8f6af.firebaseapp.com',
      databaseURL: 'https://anchor-8f6af.firebaseio.com',
      projectId: 'anchor-8f6af',
      storageBucket: 'anchor-8f6af.appspot.com',
      messagingSenderId: '284386534733',
      appId: '1:284386534733:web:a1e8f68884933dc39e8304',
    },
    VUE_APP_PAYMENT_RETURN_HOST: 'https://dev-brk.clp.kr',
    VUE_COMMON_CSS: '',
    NAVER_KEY: 'DqR82SqyO0_m3zh47q3x',
    TELEGRAM_BOT: 'anchor_dev_m_bot',
    TELEGRAM_URL: 'https://t.me/anchor_dev_m_bot?linkType=INTERNAL_LINK',
    FAVICON_URL: 'https://m-dev.clp.kr/favicon.ico',
  },
  {
    BRAND_CODE: 'anchor',
    VUE_APP_API_HOST: 'https://api-dev.clp.kr/anchor/',
    VUE_APP_API_HOST_ENTERPRISE: 'https://api-dev.clp.kr/anchor/',
    VUE_APP_API_HOST_STANDARD: 'https://api-dev.clp.kr/anchor/',
    VUE_APP_PAYMENT_HOST: 'http://localhost:8080',
    VUE_FIREBASE_INIT: {
      apiKey: 'AIzaSyA5nVm2-jac04okMOD4_qotVz3YSddVAlc',
      authDomain: 'anchor-8f6af.firebaseapp.com',
      databaseURL: 'https://anchor-8f6af.firebaseio.com',
      projectId: 'anchor-8f6af',
      storageBucket: 'anchor-8f6af.appspot.com',
      messagingSenderId: '284386534733',
      appId: '1:284386534733:web:a1e8f68884933dc39e8304',
    },
    VUE_APP_PAYMENT_RETURN_HOST: 'https://dev-brk.clp.kr',
    VUE_COMMON_CSS: '',
    NAVER_KEY: 'DqR82SqyO0_m3zh47q3x',
    TELEGRAM_BOT: 'anchor_dev_m_bot',
    TELEGRAM_URL: 'https://t.me/anchor_dev_m_bot?linkType=INTERNAL_LINK',
    FAVICON_URL: 'https://m-dev.clp.kr/favicon.ico',
  },
];

export default devConfig;
